import { z } from "zod";

const forgotpasswordSchema = z.object({
    email: z.string().email("Please enter a valid email in the format 'example@domain.com'."),
  });

export default forgotpasswordSchema;

